import { useEffect, useState } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import {
  deleteTipoCuentas, postTipoCuentas,
  getTipoCuentasPaginated
} from "../helpers/TipoCuentasData";
import { TipoCuentasForm } from "../cuentas/components/TipoCuentasForm";
import { getCategoriaCuentas } from "../cuentas/helpers/CategoriaCuentasData";
import { Grid } from "@mui/material";
import { obtenerProcesosPorPerfilYMenu } from "src/general_components/functionEsArray";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

import { TipoCuentasCard } from "../cuentas/components/TipoCuentasCard";
import { Fab, useTheme, useMediaQuery } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export const TipoCuentasList = () => {
  // eslint-disable-next-line no-unused-vars
  const [columns, setColumns] = useState([
    { field: "id", headerName: "ID", flex: 0.3 }, // la propiedad flex permite setear responsivamente el tamaño de la columna
    { field: "detalle", headerName: "Detalle", flex: 1 }, // la misma se divide entre el total y el porcentaje que le asiganas con un numero
    { field: "tipo", headerName: "Tipo", flex: 1 },
  ]);
  const listName = "Tipos de Cuentas";
  const [tipoCuenta, setTipoCuenta] = useState([]);
  const [categorias, setCategorias] = useState([])
  const [createButton, setCreateButton] = useState(false);
  const restricciones = obtenerProcesosPorPerfilYMenu();
  let alta = true;
  let baja = true;
  let modificacion = true;
  if (restricciones) {
    alta = restricciones.alta;
    baja = restricciones.baja;
    modificacion = restricciones.modificacion;
    modificacion = restricciones.modificacion;
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const getCategorias = async () => {
      const response = await getCategoriaCuentas(); //hay que ver como lo manejamos con la paginacion
      if (response) {
        setCategorias(response)
      }
    };
    getCategorias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("¿Está seguro que desea eliminar este registro?")) {
      await deleteTipoCuentas(id);
      // ListTablePaginated handle refresh usually via context or internal state, 
      // but since we are bypassing it, we might need to trigger a refresh.
      // However, standard deleteProp in options handles it.
      // Calling it manually might need manual refresh trigger.
      // For now let's rely on standard delete if possible, or force reload.
      window.location.reload();
    }
  };

  const mobileComponent = ({ row }) => (
    <TipoCuentasCard
      row={row}
      onEdit={() => {
        setTipoCuenta(row);
        setCreateButton(true);
      }}
      onDelete={handleDelete}
      permissions={{ modificacion, baja }}
    />
  );

  const [options] = useState({
    cols: columns,
    //get: getTipoCuentas,
    pageSize: [50, 100, 150, 200],
    edit: modificacion,
    delete: baja ? deleteTipoCuentas : false,
    limit: 50,
    filter: true,
    exportData: true,
    server: true,
    createButton: createButton,

    setCreateButton: setCreateButton,
    setDataEdit: setTipoCuenta,
    getPaginated: getTipoCuentasPaginated,
    hiddenButtonAgregar: !alta ? "true" : false,
    mobileComponent: mobileComponent
  });

  //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
  //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
  if (createButton === false && tipoCuenta.id !== undefined) {
    setTipoCuenta([]);
  }

  return (
    <>
      <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
        <PageHeaderCard title={listName} icon={<AccountTreeIcon />} />
        <TipoCuentasForm
          data={tipoCuenta}
          createButton={createButton}
          listName={listName}
          setCreateButton={setCreateButton}
          componentList={"/tipo_cuentas/admin"}
          postData={postTipoCuentas}
          opcionesSelector={categorias}
        />
        <ListTablePaginated options={options} />

      </Grid>
      {isMobile && (
        <Fab
          color="primary"
          aria-label="add"
          style={{
            position: 'fixed',
            bottom: 56,
            right: 20,
            zIndex: 9999
          }}
          onClick={() => {
            setTipoCuenta([]);
            setCreateButton(true);
          }}
        >
          <AddIcon />
        </Fab>
      )}
    </>
  );
};
